import React from 'react'
import Modal from 'modals/dialog'
import Content from './content'

const AddressFiller = ({ className, salt, ...props }) => {
    const {
        show = false,
        dismiss
    } = props

    return (
        <Modal
            show={show}
            dismiss={dismiss}
            className="scrollable"
            {...(className ? { contentClassName: className } : null)}
            key={`modal:address-filler:${salt}`}>
            <Content
                {...props}
                salt={`modal:address-filler:${salt}`} />
        </Modal>
    )
}

export const validate = address => (
    !!address?.line1?.trim() &&
    !!address?.postalCode?.trim() &&
    !!address?.city?.trim() &&
    !!address?.country?.trim()
)

export default AddressFiller